import React from 'react';
import t from 'rcm-i18n';
import './PwsCouponOwnerControlsComponent.scss'
import { CouponFromConfigConfig } from './types';
import { Modal } from 'forms/src';
import { addUrlParam } from '@reliv/distributor-link-creator/src';

interface Props {
    open: boolean;
    onOk: () => void;
    coupon: CouponFromConfigConfig;
}


export function CouponRowGetLinkModal({ coupon, open, onOk }: Props) {
    const exampleLink = addUrlParam(window.location.protocol + '//' + window.location.hostname + '/', 'couponCode', coupon.couponCode);

    return <Modal show={open}
        className="edit-coupon-code-get-link-popup"
        onFadeOut={onOk}
    >
        <div>
            <p>{t('You can embed this coupon code in links to your personal website.'
                + ' If someone visits one of these links, the coupon code will be automatically applied during checkout.'
                + ' Here is an example link to your homepage:')}</p>
            <a href={exampleLink} target="_blank">{exampleLink}</a>
            <br />
            <div className="clearfix button-container">
                <a className="pull-right btn btn-primary" onClick={onOk}>
                    {t('Ok')}
                </a>
            </div>
        </div>
    </Modal>
}